import { ContentMixin, MagicConfigMixin, RoutablePage } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FAQ_NAMESPACE } from '../../store/modules/faq/faq.store.js';
import { store } from '../../store/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const faqModule = namespace(FAQ_NAMESPACE);
let FaqEntriesComponent = class extends Mixins(ContentMixin, MagicConfigMixin) {
  get category() {
    return this.categories.find((category) => category.id === this.categoryId || category.slug === this.categoryId);
  }
  get categoryEntries() {
    if (!this.category) {
      return [];
    }
    return this.entries.filter((entry) => entry.catId === this.category.id);
  }
  get openedEntries() {
    return this.opened.split(",").filter(Boolean).map(Number);
  }
  created() {
    this.fetchFAQData();
  }
  fetchFAQData() {
    return __async(this, null, function* () {
      try {
        this.onContentLoadInit();
        yield this.fetchCategories(this.magicConfig.language);
        if (!this.category) {
          this.emitNotFound();
          return;
        }
        yield this.fetchEntries(this.magicConfig.language);
        this.onContentLoad({
          category: this.category,
          entries: this.categoryEntries
        });
      } catch (e) {
        this.onContentLoadError(e);
        this.routeTo({ route: RoutablePage.NOT_FOUND });
        console.error(e);
      }
    });
  }
  onLanguageChange() {
    if (this.stopRedirect) {
      this.fetchFAQData();
    } else {
      this.routeTo({ route: RoutablePage.FAQ });
    }
  }
  onContentLoad(content) {
    return content;
  }
  onToggle(index, visible) {
    return { index: String(index), visible };
  }
  emitNotFound() {
    return true;
  }
};
__decorateClass([
  Prop({ type: String, default: "" })
], FaqEntriesComponent.prototype, "categoryId", 2);
__decorateClass([
  Prop({ type: String, default: "" })
], FaqEntriesComponent.prototype, "opened", 2);
__decorateClass([
  Prop(Boolean)
], FaqEntriesComponent.prototype, "stopRedirect", 2);
__decorateClass([
  faqModule.Getter("isLoading")
], FaqEntriesComponent.prototype, "isLoading", 2);
__decorateClass([
  faqModule.Getter("categories")
], FaqEntriesComponent.prototype, "categories", 2);
__decorateClass([
  faqModule.Getter("entries")
], FaqEntriesComponent.prototype, "entries", 2);
__decorateClass([
  faqModule.Action("fetchEntries")
], FaqEntriesComponent.prototype, "fetchEntries", 2);
__decorateClass([
  faqModule.Action("fetchCategories")
], FaqEntriesComponent.prototype, "fetchCategories", 2);
__decorateClass([
  Watch("magicConfig.language")
], FaqEntriesComponent.prototype, "onLanguageChange", 1);
__decorateClass([
  Emit("contentLoad")
], FaqEntriesComponent.prototype, "onContentLoad", 1);
__decorateClass([
  Emit("entryToggle")
], FaqEntriesComponent.prototype, "onToggle", 1);
__decorateClass([
  Emit("not-found")
], FaqEntriesComponent.prototype, "emitNotFound", 1);
FaqEntriesComponent = __decorateClass([
  Component({
    name: "faq-entries",
    store
  })
], FaqEntriesComponent);

export default FaqEntriesComponent;
